// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3523":"css/app.7031","9953":"css/admin-app.7031"}[chunkId] + ".css";
};